<template>
  <OnexPage>
    <div v-if="pegaInfoExists" class="mx-auto">
      <SocialForm
        v-if="pegaReturnHTML"
        :frame-html="pegaReturnHTML"
        :params="queryParams"
        :rep-data="pegaLeadGenJSON"
      />
      <DisclosuresList
        :default-language="pegaLeadGenJSON?.language"
        :disclosures="pegaLeadGenJSON?.disclosures"
        :bg-color="'background-color-lead-gen'"
        is-lead-gen
      ></DisclosuresList>
      <FooterComponent></FooterComponent>
    </div>
  </OnexPage>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import SocialForm from '@/components/SocialForm.vue';
import DisclosuresList from '@/components/DisclosuresList.vue';
import FooterComponent from '@/components/FooterComponent.vue';
import PegaApiStore from '@/stores/pegaApi.store';
import { mapState } from 'pinia';

export default defineComponent({
  name: 'SocialLandingPage',
  props: {
    vanity: {
      type: String,
      default: '',
    },
    smpostname: {
      type: String,
      default: '',
    },
  },
  components: {
    SocialForm,
    DisclosuresList,
    FooterComponent,
  },
  data() {
    return {
      referrerSMPlatform: '',
      pegaStore: PegaApiStore(),
    };
  },
  computed: {
    ...mapState(PegaApiStore, ['pegaLeadGenJSON', 'pegaReturnHTML', 'locale']),
    pegaInfoExists(): boolean | undefined {
      if (!this.pegaLeadGenJSON) return;
      return !!Object.values(this.pegaLeadGenJSON).length;
    },
    queryParams() {
      return {
        Lang: this.$route.query.lang as string,
        SMPostName: this.smpostname,
        SMPlatform: this.referrerSMPlatform,
        Vanity: this.vanity,
      };
    },
    agentLanguage(): string {
      return this.pegaLeadGenJSON?.language ?? '';
    },
  },
  async mounted() {
    const referrer = document.referrer;
    if (referrer) {
      const host = new window.URL(referrer).hostname;
      const splitHost = host.split('.');
      this.referrerSMPlatform =
        splitHost.length > 1 ? splitHost[splitHost.length - 2] : splitHost[0];
    } else {
      this.referrerSMPlatform = '';
    }
    await this.pegaStore.setLeadGenAgentDetails(
      this.vanity,
      this.smpostname,
      this.$route,
      this.$router
    );

    if (this.pegaLeadGenJSON) {
      document.body.classList.add('no-padding');
      this.initializeAgentLanguage();
    }
  },
  methods: {
    initializeAgentLanguage() {
      this.$i18n.locale = this.locale;
    },
  },
});
</script>
